import React from 'react';
import { useForm } from '../context/FormContext';
import { requiredHistoryYears } from '../utils/validation';

export default function Step21_JobInstructions({ onNext, onBack }) {
  const { state } = useForm();
  // Same rule the entry screen enforces: 10 years, or back to age 18,
  // whichever is shorter. Show the driver their actual number, not a flat 10.
  const requiredYears = requiredHistoryYears(state.dateOfBirth);

  return (
    <div className="step-card">
      <h2 className="step-title">Employment History Instructions</h2>
      <div className="info-box" style={{ marginBottom: 20 }}>
        <strong>Please read carefully before continuing.</strong>
      </div>

      <p style={{ fontSize: 15, lineHeight: 1.7 }}>
        Please provide your work history for the past{' '}
        <strong>{requiredYears} {requiredYears === 1 ? 'year' : 'years'}</strong>.
      </p>

      <p style={{ fontSize: 15, lineHeight: 1.7, marginTop: 12 }}>
        <strong>If you were not working the entire time, that is completely normal.</strong>{' '}
        Gaps are expected -- we just need them accounted for.
      </p>

      <div className="info-box" style={{ marginTop: 16, marginBottom: 4 }}>
        <p style={{ fontSize: 15, lineHeight: 1.7, margin: 0 }}>
          <strong>Were you in school?</strong> If your history does not go back the full{' '}
          {requiredYears} {requiredYears === 1 ? 'year' : 'years'} because you were in school
          (high school, GED, trade school, or college), just add one final entry and check the
          box marked <strong>"Before this, I was in school."</strong> That closes out your
          history and you are done -- nothing earlier is needed.
        </p>
      </div>

      <p style={{ fontSize: 15, fontWeight: 700, marginTop: 20 }}>Important rules:</p>
      <ul style={{ fontSize: 15, lineHeight: 1.8, paddingLeft: 20 }}>
        <li>Start with your <strong>most recent employer</strong> and work backwards</li>
        <li>There can be <strong>no unexplained gaps greater than 30 days</strong></li>
        <li><strong>Unemployment counts.</strong> Self-employment counts. Disability counts. Medical leave counts. Personal time between jobs counts.</li>
        <li>
          For time you were <strong>not working</strong>, add it as an entry and enter{' '}
          <strong>your home city and state</strong> for that period
        </li>
        <li>For each entry you will need: employer name, city and state at minimum, start date, and position held</li>
        <li><strong>End dates fill in automatically</strong> from the entry above -- you do not enter them</li>
        <li>Dates are <strong>approximate</strong> (month and year) -- exact dates are not required</li>
      </ul>

      <div style={{ marginTop: 24 }}>
        <button className="btn-next" style={{ width: '100%', padding: 18, fontSize: 17 }} onClick={onNext}>
          I Understand &mdash; Continue
        </button>
      </div>
      <div style={{ marginTop: 12 }}>
        <button className="btn-back" style={{ width: '100%' }} onClick={onBack}>&larr; Back</button>
      </div>
    </div>
  );
}
